<template>
  <div class="doc-content text-left">
    <template v-for="(section, index) in resolvedSections">
      <doc-accordion v-if="section.accordion" :key="index" :title="section.title">
        <doc-content :sections="section.sections" :context="context" />
      </doc-accordion>
      <doc-block v-else :key="index" :id="section.block" :context="context" />
    </template>
  </div>
</template>

<script>
import { getDoc } from '@/docs'
import DocBlock from '@/components/Docs/DocBlock'
import DocAccordion from '@/components/Docs/DocAccordion'

// Renders a doc (`doc` id from src/docs/docs.js) or an ad-hoc list of `sections`
// (block ids and/or accordions, same shape as in docs.js).
export default {
  name: 'DocContent',
  components: { DocBlock, DocAccordion },
  props: {
    doc: { type: String, default: null },
    sections: { type: Array, default: null },
    // Data for dynamic items, e.g. { eventTypes }
    context: { type: Object, default: () => ({}) }
  },
  computed: {
    resolvedSections() {
      const list = this.sections || (this.doc && getDoc(this.doc) ? getDoc(this.doc).sections : [])

      return list.map((section) => {
        if (typeof section === 'string') return { block: section }

        const nested = section.doc && getDoc(section.doc) ? getDoc(section.doc).sections : section.sections
        return { accordion: true, title: section.title, sections: nested || [] }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Docs/DocContent.vue